module.exports = __webpack_public_path__ + "img/Plus.60fca649.svg";